import { ref } from 'vue'

const isModalOpen = ref(false)
const brevoLink = 'https://meet.brevo.com/angie-marriaga'

export function useDemoModal() {
  const openModal = () => {
    isModalOpen.value = true
  }

  const closeModal = () => {
    isModalOpen.value = false
  }

  return {
    isModalOpen,
    brevoLink,
    openModal,
    closeModal
  }
}
